import React from 'react';

import { useQueryClient, useMutation } from '@tanstack/react-query';

import Table from '../../../../../Table';
import FormContainer from '../../../../FormContainer';
import TypeDropdown from './TypeDropdown';
import DocumentActions from './DocumentActions';

import useInsuranceDocumentForm from '../../../../../../forms/loan/insuranceDocument';
import { useUiContext } from '../../../../../../context/UiContext';
import InsuranceService from '../../../../../../services/InsuranceService';
// import LoanService from '../../../../../../services/LoanService';

export default function Documents({
  loanId,
  insurance,
  refetchLoan,
  refetchInsurance,
  readOnly,
}) {
  const { showToast } = useUiContext();

  const queryClient = useQueryClient();

  const { mutate: updateInsuranceWithDocuments } = useMutation({
    mutationFn: async ({ formValues, message }) => {
      const result = await InsuranceService.updateInsurance({
        formValues,
        insuranceId: insurance?.id,
      });

      return {
        result,
        message,
      };
    },
    onSuccess: (data) => {
      showToast({
        text: data.message,
        type: 'success',
      });
      refetchLoan();
      refetchInsurance();
      queryClient.invalidateQueries({
        queryKey: ['loanDocumentsForm', loanId],
      });
    },
    onError: () => {
      showToast({
        text: 'Something went wrong',
        type: 'error',
      });
    },
  });

  const cols = [
    {
      title: 'Document',
      keys: ['_document.private_document.name'],
    },
    {
      title: 'Type',
      keys: ['type'],
      type: 'component',
      component: TypeDropdown,
      props: (row) => ({
        readOnly,
        value: row.type,
        options: [
          { value: 'declarations', label: 'Declarations' },
          { value: 'invoice', label: 'Invoice' },
          { value: 'binder', label: 'Binder' },
          { value: 'other', label: 'Other' },
        ],
        updateType: (value) =>
          updateInsuranceWithDocuments({
            formValues: {
              ...insurance,
              documents: insurance.documents.map((doc) =>
                doc.document_id === row.document_id && doc.type === row.type
                  ? { ...doc, type: value }
                  : doc
              ),
            },
            message: 'Document updated',
          }),
      }),
    },
    {
      title: 'Actions',
      type: 'component',
      component: DocumentActions,
      props: (row) => ({
        updateInsuranceWithDocuments,
        insurance,
        row,
        readOnly,
      }),
    },
  ];

  const form = useInsuranceDocumentForm(
    (formValues) =>
      updateInsuranceWithDocuments({
        formValues: {
          ...insurance,
          documents: [...insurance.documents, { ...formValues }],
        },
        message: 'Document created',
      }),
    loanId
  );

  return (
    <div>
      <Table title="Documents" rows={insurance?.documents} cols={cols} />
      {!readOnly && (
        <FormContainer form={form} noTitle noBillComId inlineSubmitButton />
      )}
    </div>
  );
}
